import FormattedMessage from 'I18n/components/FormattedMessage';
import styled from 'styled-components';
import UIAlert from 'UIComponents/alert/UIAlert';
import UIButton from 'UIComponents/button/UIButton';
import UIButtonWrapper from 'UIComponents/layout/UIButtonWrapper';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledUIAlert = styled(UIAlert).withConfig({
  displayName: "EditorTabAlert__StyledUIAlert",
  componentId: "sc-19t4ebp-0"
})(["width:100%;"]);
export function EditorTabAlert({
  reset
}) {
  return /*#__PURE__*/_jsx(StyledUIAlert, {
    titleText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "composer-ui.tabbed-editor.editor-tab-alert.title"
    }),
    type: "danger",
    children: /*#__PURE__*/_jsxs(UIButtonWrapper, {
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "composer-ui.tabbed-editor.editor-tab-alert.text"
      }), /*#__PURE__*/_jsx(UIButton, {
        size: "extra-small",
        use: "tertiary",
        onClick: reset,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "composer-ui.tabbed-editor.editor-tab-alert.reset-button"
        })
      })]
    })
  });
}
EditorTabAlert.displayName = 'EditorTabAlert';